import { motion } from "framer-motion";
import { ATHENA } from "@/constants/testIds";

const TEAM = [
  {
    slug: "aadil-khan",
    name: "Aadil Khan",
    role: "Founder · CEO",
    bio: "",
  },
  {
    slug: "skanth-rohan-manian",
    name: "Skanth Rohan Manian",
    role: "Founder · CPO",
    bio: "",
  },
  {
    slug: "sahil-khan",
    name: "Sahil Khan",
    role: "Founder · CFO",
    bio: "",
  },
];

export const Team = () => {
  return (
    <section
      data-testid={ATHENA.teamSection}
      className="relative pt-10 md:pt-14 pb-10 md:pb-14 border-t border-[#D5D1C8] bg-[#EAE7E0]/40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <span className="label-mono">// FOUNDERS</span>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.04] tracking-tight text-[#0A1713]">
              The minds behind
              <br />
              Athena.
            </h2>
          </div>
          <p className="max-w-md text-[#3D4F46]">
            Athena Nutrascience is built by three founders bringing together
            science, product and business — united by a belief that formulations
            should be earned, not assembled.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#D5D1C8] border border-[#D5D1C8]">
          {TEAM.map((t, i) => (
            <motion.div
              key={t.slug}
              data-testid={ATHENA.teamMember(t.slug)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-[#F8F7F4] p-8 md:p-10 min-h-[140px] md:min-h-[240px] flex flex-row md:flex-col items-center md:items-start gap-6 md:gap-0"
            >
              <div className="aspect-square w-16 rounded-full bg-[#1A382A] text-[#F8F7F4] flex items-center justify-center font-display text-2xl shrink-0 md:mb-6">
                {t.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-2xl text-[#0A1713] leading-tight">
                  {t.name}
                </div>
                <div className="label-mono mt-1">{t.role}</div>
                {t.bio && (
                  <p className="mt-5 text-sm text-[#3D4F46] leading-relaxed">{t.bio}</p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
